// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import toast from 'react-hot-toast'

// ** Axios Imports
import axios from 'axios'

export const clearData = createAsyncThunk('appInvoice/clearData', async params => {
  return params
})

export const getData = createAsyncThunk('appInvoice/getData', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/getrequestsV4Time', params)
  // console.log(response.data.invoices)
  return {
    params,
    data: response.data.invoices,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})
export const getDataArch = createAsyncThunk('appInvoice/getData', async params => {
  clearData([])
  const response = await axios.post('https://api.fntpf.ir/admin/getrequestsArchV3Time', params)
   console.log('AshKB', response.data)
  return {
    params,
    data: response.data.invoices,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const getDataDel = createAsyncThunk('appInvoice/getData', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/getrequestsDel', params)
  // console.log('removed', response.data)
  return {
    params,
    data: response.data.invoices,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const getDevices = createAsyncThunk('appInvoice/getDevices', async () => {
  const response = await axios.post('https://api.fntpf.ir/get/products')
  // console.log('dddd', response.data.allData)
  return response.data.allData
})

export const getNewInvoiceId = createAsyncThunk('appInvoice/getNewInvoiceId', async () => {
  const response = await axios.post('https://api.fntpf.ir/admin/getNewInvoiceNumber')
  console.log('dddd', response.data)
  return response.data.results
})

export const changeLoading = createAsyncThunk('appInvoice/changeLoading', async (state) => {
  // console.log('dddd', response.data.allData)
  return state
})

export const getBrand = createAsyncThunk('appInvoice/getBrand', async (params) => {
  // console.log('BRand', params)
  const response = await axios.post('https://api.fntpf.ir/admin/getProductBrand', params)
  if (response.data.status) return response.data.brand
  else return {brand: '-'}
})

export const getAgentInfo = createAsyncThunk('appInvoice/getAgentInfo', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/getAgentInfo', params)
  // console.log('Store agent', response.data.agent)
  return response.data.agent
})

export const getScore = createAsyncThunk('appInvoice/getScore', async params => {
  const response = await axios.post('https://api.fntpf.ir/rating/getAdminScore', params)
  // console.log('Score: ', response.data.score)
  return response.data.score
})

export const getAdminScore = createAsyncThunk('appInvoice/getAdminScore', async params => {
  const response = await axios.post('https://api.fntpf.ir/rating/getSelfAdminScore', params)
  // console.log('AdminScore: ', response.data.score)
  return response.data.score
})

export const getTracking = createAsyncThunk('appInvoice/getTracking', async params => {
  // console.log('TRACKTEST')
  const response = await axios.post('https://api.fntpf.ir/tracking/getItem', params)
  // console.log('trace: ', response.data)
  if (response.data.data) return response.data.data
  else return {}
})

export const getInvoiceDetails = createAsyncThunk('appInvoice/getInvoiceDetails', async params => {
  const response = await axios.post('https://api.fntpf.ir/invoice/invoice_details', params)
  if (response.data.status) {
    return response.data
  } else {
    toast.error('خطای دیتا بیس')
    return false
  }
})

export const setEdit = createAsyncThunk('appInvoice/setEdit', async params => {
    // const response = await axios.post('https://api.fntpf.ir/admin/changeRequestStatus', params)
    return params
})

export const getProvinceAgents = createAsyncThunk('appInvoice/getProvinceAgents', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/getProvinceAgents', params)
  // console.log('Store prov', response.data.agent)
  return response.data.agents
})

export const addAgent = createAsyncThunk('appInvoice/addAgentToReq', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/addAgentToReq', params)
  if (response.data.status) {
    toast.success('با موفقیت تخصیص داده شد.')
  } else {
    toast.error('اشکال در ارتباط با سرور')
  }
  return response.data
})

export const activateReq = createAsyncThunk('appInvoice/activate', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/changeStatus', params)
  if (response.data.status) {
    toast.success('با موفقیت اعمال شد.')
  } else {
    toast.error('اشکال در ارتباط با سرور')
  }
  return response.data
})

export const removeAgent = createAsyncThunk('appInvoice/removeAgent', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/removeAgentFromReq', params)
  if (response.data.status) {
    toast.success('با موفقیت حذف شد.')
  } else {
    toast.error('خطای سرور')
  }
  return response.data
})

export const sendMessage = createAsyncThunk('appInvoice/sendMessage', async params => {
  // console.log(params)
  const response = await axios.post('https://api.fntpf.ir/admin/sendMessage', params)
  if (response.data.status) {
    toast.success('پیامک ارسال شد.')
    window.locate('/')
  } else {
    toast.error('خطای در ارسال پیامک')
  }
  return response.data
})

export const removeCostItem = createAsyncThunk('appInvoice/removeCostItem', async params => {
  const response = await axios.post('https://api.fntpf.ir/invoice/admin/removeItem', params)
  if (response.data.status) {
    toast.success('با موفقیت حذف شد.')
  } else {
    toast.error('خطای سرور')
  }
  return response.data
})

export const addInvoiceItem = createAsyncThunk('appInvoice/addInvoiceItem', async params => {
  const response = await axios.post('https://api.fntpf.ir/invoice/admin/addItem', params)
  if (response.data.status) {
    toast.success('با موفقیت افزوده شد.')
  } else {
    toast.error('خطای سرور')
  }
  return response.data
})

export const saveEditToDb = createAsyncThunk('appInvoice/saveEditToDb', async params => {
  const response = await axios.post('https://api.fntpf.ir/invoice/admin/edit', params)
  if (response.data.status) {
    toast.success('با موفقیت ذخیره شد.')
  }
  return response.data
})

export const deleteInvoice = createAsyncThunk('appInvoice/deleteInvoice', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/invoice/delete', { id })
  await dispatch(getData(getState().invoice.params))
  return id
})


export const addInvoice = createAsyncThunk('appInvoice/addInvoice', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/addAddress', params)
  if (response.data.status) {
    toast.success('آدرس جدید اضافه شد.')
  } else toast.error(response.data.error)
  return response.data
})

export const setCustomerInfo = createAsyncThunk('appInvoice/setCustomerInfo', async params => {
  console.log('params', params)
  return params
})

export const setDeviceInfo = createAsyncThunk('appInvoice/setDeviceInfo', async params => {
  return params
})

export const appInvoiceSlice = createSlice({
  name: 'appInvoice',
  initialState: {
    loading: true,
    data: [],
    total: 1,
    params: {},
    allData: [],
    agent_info: {},
    province_agents: [],
    changeStatus: {},
    products: [],
    deviceInfo: {},
    customerInfo: {},
    invoiceDetails:[],
    invoice:{},
    edit: {},
    brand: {},
    score: {},
    adminScore: {},
    trackingDetails: {},
    newReqId: 0,
    newInvoiceId: ''
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
      state.loading = false
    }).addCase(getAgentInfo.fulfilled, (state, action) => {
      state.agent_info = action.payload
    }).addCase(clearData.fulfilled, (state, action) => {
      state.data = action.payload
    }).addCase(getProvinceAgents.fulfilled, (state, action) => {
      state.province_agents = action.payload
    }).addCase(addAgent.fulfilled, (state, action) => {
      state.changeStatus = action.payload
    }).addCase(removeAgent.fulfilled, (state, action) => {
      state.changeStatus = action.payload
    }).addCase(activateReq.fulfilled, (state, action) => {
      state.changeStatus = action.payload
    }).addCase(getDevices.fulfilled, (state, action) => {
      state.products = action.payload
    }).addCase(getBrand.fulfilled, (state, action) => {
      state.brand = action.payload
    }).addCase(setCustomerInfo.fulfilled, (state, action) => {
      state.customerInfo = action.payload
    }).addCase(setDeviceInfo.fulfilled, (state, action) => {
      state.deviceInfo = action.payload
    }).addCase(getScore.fulfilled, (state, action) => {
      state.score = action.payload
    }).addCase(getAdminScore.fulfilled, (state, action) => {
      state.adminScore = action.payload
    }).addCase(getTracking.fulfilled, (state, action) => {
      state.trackingDetails = action.payload
    }).addCase(getInvoiceDetails.fulfilled, (state, action) => {
      state.invoice = action.payload.factor
      state.invoiceDetails = action.payload.cost
      if (action.payload.factor && action.payload.factor.length > 0) {
        state.edit = {
          warranty: action.payload.factor.warranty,
          status: action.payload.factor.status,
          cancel_reason: action.payload.factor.cancel_reason,
          description: action.payload.factor.description
        }
      }
    }).addCase(removeCostItem.fulfilled, (state, action) => {
      state.changeStatus = action.payload
    }).addCase(changeLoading.fulfilled, (state, action) => {
      state.loading = action.payload
    }).addCase(addInvoice.fulfilled, (state, action) => {
      state.newReqId = action.payload.reqId
    }).addCase(getNewInvoiceId.fulfilled, (state, action) => {
      state.newInvoiceId = action.payload
    }).addCase(addInvoiceItem.fulfilled, (state, action) => {
      state.changeStatus = action.payload
    }).addCase(setEdit.fulfilled, (state, action) => {
      console.log(action.payload)
      if (action.payload.type === 'due_date') {
        state.edit.due_date = action.payload.value
      }
      if (action.payload.type === 'warranty') {
        state.edit.warranty = action.payload.value
      }
      if (action.payload.type === 'cancel') {
        state.edit.status = action.payload.value
      }
      if (action.payload.type === 'cancel_reason') {
        state.edit.cancel_reason = action.payload.value
      }
      if (action.payload.type === 'desc') {
        state.edit.description = action.payload.value
      }
      if (action.payload.type === 'due') {
        state.edit.due_date = action.payload.value
      }
    })
  }
})

export default appInvoiceSlice.reducer
